import React, { Component } from "react";

import StepPreviewContainer from "components/Common/StepThumbnail/StepPreviewContainer";
import StepPreviewFooter from "components/Common/StepThumbnail/StepPreviewFooter";
import StepPreviewHeader from "components/Common/StepThumbnail/StepPreviewHeader";
import StepContainer from "components/Common/StepThumbnail/StepContainer";

export class StepPreviewThumbnail extends Component {
  state = {
    showHoverComponent: false
  };

  showHoverComponent = () => {
    this.setState({
      showHoverComponent: true
    });
  };

  hideHoverComponent = () => {
    this.setState({
      showHoverComponent: false
    });
  };

  render() {
    const {
      childIndex,
      children,
      stepType,
      totalSteps,
      onHoverComponent,
      className
    } = this.props;
    const { showHoverComponent } = this.state;
    return (
      stepType && (
        <StepPreviewContainer
          onMouseEnter={this.showHoverComponent}
          onMouseLeave={this.hideHoverComponent}
          className={className}
        >
          <StepPreviewHeader
            childIndex={childIndex}
            stepTypeId={stepType && stepType.id}
            totalSteps={totalSteps}
          />

          <StepContainer>
            {showHoverComponent && onHoverComponent}
            {children}
          </StepContainer>
          <StepPreviewFooter
            stepTypeId={stepType && stepType.id}
            childIndex={childIndex}
          />
        </StepPreviewContainer>
      )
    );
  }
}

export default StepPreviewThumbnail;
